import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiMail } from 'react-icons/fi';

import { useActions, useNavigationUtils } from '@mssgme/hooks';
import { LimitRequestsError } from '@mssgme/api-client';
import { useEnhancedFormik, FormField, Button } from '@mssgme/ui';
import { GoogleLoginButton, AppleLoginButton, SocialLoginButton } from '../../../UI';

import styles from './styles.scss';

export default function LoginForm() {
    const { t } = useTranslation('auth');
    const actions = useActions();
    const [isEmailFormVisible, setIsEmailFormVisible] = useState(false);
    const { generateUrl } = useNavigationUtils();

    const formik = useEnhancedFormik({
        initialValues: {
            username: '',
            password: '',
        },
        onSubmit: async (payload) => {
            const { redirect } = await actions.api.auth.login({ payload });
            window.location.replace(redirect || '/');
        },
    });

    const limitRequestError = LimitRequestsError.is(formik.submit.error) ? formik.submit.error.message : null;

    return (
        <form onSubmit={formik.handleSubmit}>
            <GoogleLoginButton backgroundColor="#db4a39" id="button-login-google" />
            <AppleLoginButton iconBorderColor="#222" id="button-login-apple" />
            {!isEmailFormVisible && (
                <SocialLoginButton
                    icon={FiMail}
                    as="div"
                    onClick={() => setIsEmailFormVisible(true)}
                    id="button-login-show-email-form"
                >
                    {t('auth.loginWith', { provider: 'Email' })}
                </SocialLoginButton>
            )}
            {isEmailFormVisible && (
                <>
                    <FormField
                        builderInput
                        placeholder={t('label.email')}
                        name="username"
                        type="email"
                        value={formik.values.username}
                        onChange={formik.handleChange}
                        autoComplete="email"
                        style={{ height: 44, fontSize: 18, marginTop: 16 }}
                    />
                    <FormField
                        builderInput
                        placeholder={t('label.password')}
                        name="password"
                        type="password"
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        autoComplete="current-password"
                        errors={formik.errors.username || limitRequestError}
                        style={{ height: 44, fontSize: 18 }}
                        errorStyle={{ fontSize: 16, textAlign: 'center' }}
                    />
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button
                            fullWidth
                            type="submit"
                            isFetching={formik.isSubmitting || formik.status === 'success'}
                            style={{
                                fontSize: 18,
                                fontWeight: 'bold',
                                backgroundColor:
                                    formik.isSubmitting || formik.status === 'success' ? 'transparent' : '#007aff',
                            }}
                            id="button-login-email"
                        >
                            {t('auth.signin.signin')}
                        </Button>
                    </div>
                </>
            )}
            <div className={styles.footer}>
                <span>
                    {t('auth.signin.noAccount')}{' '}
                    <Link style={{ color: '#007aff' }} to={generateUrl('../signup')}>
                        {t('auth.signin.signup')}
                    </Link>
                </span>
                {isEmailFormVisible && (
                    <span>
                        {t('auth.signin.forget')}{' '}
                        <Link style={{ color: '#007aff' }} to={generateUrl('../restore')}>
                            {t('auth.signin.restore')}
                        </Link>
                    </span>
                )}
            </div>
        </form>
    );
}
